import React from 'react'
import LogoImg from 'i/icons/talkpro_logo_white.svg'

import style from './Logo.module.scss'

const Logo = () => {
  return (
    <a className={style.logo} href="https://join.talkpro.com">
      <img src={LogoImg} className={style.logoImage} alt="" />
    </a>
  )
}

export default Logo
